import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { memberApi, formatApiError } from "../api";

export default function ResetPassword() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const token = search.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== pw2) return setError("Passwords do not match.");
    if (!token) return setError("Reset link is invalid or expired.");
    setSubmitting(true);
    try {
      await memberApi.post("/api/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/app/login"), 2500);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#0a0a0a]" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-8 shadow-2xl">
        <h1 className="text-3xl font-light text-[#C97654] mb-6 text-center">Set New Password</h1>

        {done ? (
          <div data-testid="reset-success" className="bg-[#C97654]/20 border border-[#C97654] rounded-lg px-4 py-4 text-center">
            <p className="text-[#FFB89A] font-bold mb-1">Password updated ✓</p>
            <p className="text-[#E8DCC4]/70 text-sm">Redirecting to sign in…</p>
          </div>
        ) : (
          <>
            {error && <div className="mb-4 bg-[#8B2635]/20 border border-[#8B2635] rounded-lg px-4 py-3 text-[#FFB89A] text-sm">{error}</div>}
            <form onSubmit={onSubmit} className="space-y-4">
              <input
                type="password"
                required
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                placeholder="New password (8+ characters)"
                data-testid="reset-password-input"
                className="w-full bg-[#0a0a0a] border-2 border-[#2a2a2a] focus:border-[#C97654] rounded-lg px-4 py-3 text-[#E8DCC4] placeholder-[#E8DCC4]/30 outline-none"
                autoComplete="new-password"
              />
              <input
                type="password"
                required
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                placeholder="Confirm password"
                data-testid="reset-confirm-input"
                className="w-full bg-[#0a0a0a] border-2 border-[#2a2a2a] focus:border-[#C97654] rounded-lg px-4 py-3 text-[#E8DCC4] placeholder-[#E8DCC4]/30 outline-none"
                autoComplete="new-password"
              />
              <button
                type="submit"
                disabled={submitting}
                data-testid="reset-submit-btn"
                className="w-full bg-gradient-to-r from-[#C97654] to-[#FF9472] text-white py-3 rounded-lg font-bold shadow-md disabled:opacity-50"
              >
                {submitting ? "Updating…" : "Update Password"}
              </button>
            </form>
          </>
        )}

        <div className="mt-6 text-center text-sm">
          <Link to="/app/login" className="text-[#E8DCC4]/70 hover:text-[#C97654]">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
